import React from 'react';

const RegisterUserContext = React.createContext({});

export default RegisterUserContext;
